module.exports = "/assets/sample2-34006d0500ef831322b3813e349f322f.jpg";